export const getBaseUrl = () => {
  const appEnvironment = process.env.VITE_APP_ENV;
  if (appEnvironment === "dev") {
    return "https://dev.my-kaboodle.ai/";
  } else if (appEnvironment === "prod") {
    return "https://my-kaboodle.ai/";
  } else if (appEnvironment === "local") {
    return "https://local.my-kaboodle.ai:8000/";
  }
  throw new Error(`Unknown VITE_APP_ENV: ${appEnvironment}`);
};
